module.exports = __webpack_public_path__ + "b03b15c0c5e4d090d4ecd05c03b48453.svg";